import React from 'react';
import PropTypes from 'prop-types';

import OELicensingAccessProvider from '../../react-oe/oe-licensing-access-provider';
import {OEAppInitResultCode, OEHideFlags} from '../../react-oe/oe-types';
import OEIconCodes from '../../lib/oe-icon-codes';
import {OEFNWelcomeEntryTypes} from '../views/flow-nav/welcome/oe-fn-welcome-model';
import OEFNStartView from '../views/start-view/oe-flow-nav-start-view';
import {OEFNStartSelectionContentFactory, OEFNStartSelectionModel} from '../views/flow-nav/start-selection/oe-fn-start-selection-model';
import OEToolbox from '../../lib/tools/oe-toolbox';

export const OEProtoStartViewEntryTypes = Object.assign({}, OEFNWelcomeEntryTypes, {
    demo:           'demo',
    targetType:     'targetType'
});

export default class OEProtoStartView extends React.PureComponent {

    constructor(props) {
        super(props);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.onClick = this.onClick.bind(this);

        // note that this.onClick is used in createEntries, thus call it after this.onClick = this.onClick.bind(this);
        this.state = {
            entries: this.createEntries()
        };

        this.onLicensingAccess = this.onLicensingAccess.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        if(!OEToolbox.shallowEqual(nextProps.entries, this.props.entries, true) || nextProps.featureAccess !== this.props.featureAccess || nextProps.startSelectionData !== this.props.startSelectionData)  {
            this.setState({entries: this.createEntries(nextProps)});
        }
    }

    mapEntries(entries, props) {
        if(!Array.isArray(entries))  return;

        return entries.map(entry => {
            if(entry.type === OEFNWelcomeEntryTypes.maskBlock)  {
                return Object.assign({}, entry, {entries: this.mapEntries(entry.entries, props)});
            }

            let {target, targetType, ...rest} = entry;
            let ret = Object.assign({proto: entry}, rest);

            //
            if(ret.type === OEProtoStartViewEntryTypes.targetType)    {
                let startSelection = entry.startSelection || (props.startSelectionData ? props.startSelectionData.choose(targetType) : undefined);

                //
                let enabled = OEFNStartSelectionModel.itemCount(startSelection) > 0;
                if(enabled && props.featureAccess)    {
                    enabled = props.featureAccess.isModuleAvailableForLicensingAccess(this.licensingAccess, targetType)
                }

                //
                let doStartSelection = OEFNStartSelectionModel.itemCount(startSelection) > 1;

                if(doStartSelection && props.featureAccess)    {
                    doStartSelection = props.featureAccess.isTargetSelectionAvailableForLicensingAccess(this.licensingAccess, targetType)
                }

                if(doStartSelection)    {
                    if(OEFNStartSelectionContentFactory.isContent(startSelection))   startSelection = {content: startSelection};
                    if(startSelection.currentItemInactive === undefined)    startSelection.currentItemInactive = false;
                }

                //
                ret.type = !doStartSelection ? OEFNWelcomeEntryTypes.menu : OEFNWelcomeEntryTypes.startSelection;
                ret.enabled = entry.enabled !== undefined ? entry.enabled : enabled;
                ret.targetType = targetType;
                ret.startSelection = doStartSelection ? startSelection : undefined;
                ret.onClick = !doStartSelection ? this.onClick : undefined;
            }

            //
            if(ret.type === OEProtoStartViewEntryTypes.demo)    {
                ret.type = OEFNWelcomeEntryTypes.menu;
                ret.onClick = this.onClick;
            }
           
            //
            if(!ret.viewTitle && typeof(ret.viewTitle) !== 'string')    {
                if(ret.type === OEFNWelcomeEntryTypes.startSelection)   ret.viewTitle = {titleId: 'welcome_view_start_selection', icon: OEIconCodes.startSelection};
                if(ret.type === OEFNWelcomeEntryTypes.help) ret.viewTitle = 'help_view_title';
                if(ret.type === OEFNWelcomeEntryTypes.infoHelp) ret.viewTitle = 'help_info_view_title';
            }

            return ret;
        });
    }

    createEntries(props)    {
        props = props || this.props;
        return this.mapEntries(props.entries, props);
    }

    onLicensingAccess(licensingAccess) {
        this.licensingAccess = licensingAccess;
        this.setState({entries: this.createEntries()});
    }

    render()    {
        let {fref, helpViewConfig, entries, ...rest} = this.props;

        return (
            <React.Fragment>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>
                <OEFNStartView
                    {...rest}
                    ignoreDontShowStartViewAtStartUp={true}
                    showCloseBtnAllways={false}
                    coreHideFlags={OEHideFlags.scene}
                    entries={this.state.entries}
                    help={{showLogo: true, entries: helpViewConfig.entries, manualViewLinks: helpViewConfig.manualViewLinks}}
                    ref={fref}
                />
            </React.Fragment>
        );
    }

    onClick(id, sender, entry)   {
        let props = this.props;

        if(!props.appComponent || !props.appComponent.uiLayer || !props.appComponent.app)   return;

        let proto = entry && entry.proto ? entry.proto : {};

        let targetType = proto.targetType;
        let target = proto.target;
        let type = proto.type;
        let startSelectionAfterTargetChange = !!proto.startSelectionAfterTargetChange;

        if(targetType && !target && props.versionTargets)   target = type === OEProtoStartViewEntryTypes.demo ? props.versionTargets.demoTargetForType(targetType) : props.versionTargets.defaultTargetForType(targetType);

        if(props.appComponent.app.changeTarget(target, (result, oe) => {
            if(!startSelectionAfterTargetChange || type === OEProtoStartViewEntryTypes.demo || result.code !== OEAppInitResultCode.ok || result.target !== target || !oe.isReady() || OEFNStartSelectionModel.itemCount(props.appComponent.app.config.module.uiLayerConfig.startSelection) < 2) return;
            if(!props.featureAccess || props.featureAccess.determineTargetSelectionAvailableForTarget(oe, target))    props.appComponent.uiLayer.startSelectionView.setOpen(true);
        }))    {
            props.appComponent.uiLayer.startView.close();
        }
    }
}

OEProtoStartView.defaultProps = {
    className: '',
    moduleId: ''
};

OEProtoStartView.propTypes = {
    className: PropTypes.string,
    moduleId: PropTypes.string,
    versionTargets: PropTypes.object,
    featureAccess: PropTypes.object,
    startSelectionData: PropTypes.object
};